<aux-extendable-options-dropdown
  class="program-project-dropdown"
  [items]="items!()"
  [dropdownControl]="formControl"
  [openOnInit]="true"
  [resetValueOnEscapePress]="true"
  [initialSearchTerm]="initialSearchTerm"
  (clickOut)="stopEditing()"
  (confirm)="stopEditing()"
  (addOption)="onAddOption($event)"
  (changed)="$event && stopEditing()"
/>
